angular.module("UI8.components").component("tagFilter", {
  template:
    "<div class='filters__tags filters__tags--category' on-load='$ctrl.changeHandler()'>" +
    "  <div class='filters__scroll'>" +
    "    <div class='filters__inner'>" +
    "      <button class='filters__btn' ng-class='$ctrl.isActive(tag._id)' ng-click='$ctrl.updateFilter()'>All products</button>" +
    "      <button class='filters__btn' ng-class='$ctrl.isActive(tag._id)' ng-if='tag' ng-click='$ctrl.updateFilter(tag._id)' ng-repeat='tag in ::$ctrl.filters track by tag._id'>" +
    "        <span data-tag-id='{{ ::tag._id }}'>{{ ::$ctrl.capitalize(tag.name) }}</span>" +
    "      </button>" +
    "    </div>" +
    "  </div>" +
    "  <button class='filters__nav filters__nav--prev'></button>" +
    "  <button class='filters__nav filters__nav--next'></button>" +
    "</div>",

  controller: function () {
    var ctrl = this;
    var slug;

    ctrl.changeHandler = function () {
      slug = location.pathname.split("/").pop();
      var filter = sessionStorage.getItem(slug + ":tag-filter");
      ctrl.updateFilter(filter ? filter : null);
      document.body.addEventListener("reset-category-filters", resetListener);
    };

    ctrl.$onInit = function () {
      ctrl.filters = ctrl.filters.filter(function (tag) {
        return !!tag;
      });

      if (
        /sale/i.test(ctrl.categoryName) ||
        /trending/i.test(ctrl.categoryName)
      ) {
        ctrl.categoryName = "Products";
      }

      // Added delay to ensure DOM is ready
      setTimeout(function () {
        // Tags scroll navigation
        var tags = $(".filters__tags--category"),
          scroll = tags.find(".filters__scroll"),
          inner = scroll.find(".filters__inner"),
          nav = tags.find(".filters__nav");

        // Check if tags are scrollable
        if (inner.width() > scroll.width()) {
          tags.addClass("is-next");
        }

        // Tags scroll navigation
        nav.on("click", function () {
          var _this = $(this),
            scrollOffset = scroll.width() / 2;

          if (_this.hasClass("filters__nav--prev")) {
            scroll.scrollLeft(scroll.scrollLeft() - scrollOffset);
          } else {
            scroll.scrollLeft(scroll.scrollLeft() + scrollOffset);
          }
        });

        function updateScroll() {
          const el = scroll[0];
          const scrollLeft = el.scrollLeft;
          const maxScrollLeft = el.scrollWidth - el.clientWidth;

          // At start?
          if (scrollLeft > 0) {
            tags.addClass("is-prev");
          } else {
            tags.removeClass("is-prev");
          }

          // At end?
          if (scrollLeft < maxScrollLeft - 1) {
            tags.addClass("is-next");
          } else {
            tags.removeClass("is-next");
          }
        }

        // Add scroll event listener
        scroll.on("scroll", updateScroll);

        // Add resize event listener
        $(window).on("resize", updateScroll);

        updateScroll();
      }, 10);
    };

    ctrl.$onDestroy = function () {
      document.body.removeEventListener(
        "reset-category-filters",
        resetListener
      );
    };

    // Set Active Selection
    ctrl.updateFilter = function (tagId) {
      tagId = tagId || null;
      if (tagId) sessionStorage.setItem(slug + ":tag-filter", tagId);
      else sessionStorage.removeItem(slug + ":tag-filter");
      ctrl.currentFilter = tagId;
      ctrl.onUpdate({ value: tagId });

      // Scroll top after updating filters
      var header = $(".header"),
        trigger = $(".page__trigger"),
        filters = $(".page__filters--sticky");

      if (filters.hasClass("scrolled"))
        window.scroll(0, trigger.offset().top - header.outerHeight());
    };

    // Set class name for active selection
    ctrl.isActive = function (tagId) {
      if (!ctrl.currentFilter && !tagId) return "active";
      return tagId === ctrl.currentFilter ? "active" : "";
    };

    // Capitalize tag names
    ctrl.capitalize = function (text) {
      return text
        .split(" ")
        .map(function (word) {
          if (/ios/i.test(word)) return "iOS";
          if (/iphone/i.test(word)) return "iPhone";
          if (/ipad/i.test(word)) return "iPad";
          if (/imac/i.test(word)) return "iMac";
          if (/macbook/i.test(word)) return "MacBook";
          if (/html/i.test(word)) return "HTML";
          if (/ai/i.test(word)) return "AI";
          return word.substring(0, 1).toUpperCase() + word.substring(1);
        })
        .join(" ");
    };

    function resetListener() {
      if (ctrl.currentFilter) ctrl.updateFilter();
    }
  },

  bindings: {
    filters: "<",
    categoryName: "<",
    onUpdate: "&",
  },
});
